import { Checkbox as CheckboxPrimitive } from "@base-ui/react/checkbox";
import { CheckIcon } from "lucide-react";

import { cn } from "@lib/utils";

/** A control that allows the user to toggle between checked and not checked.
 * @prop className - The class name to apply to the checkbox.
 * @prop required - Whether the checkbox is required.
 */
export const Checkbox = ({
	className,
	required = false,
	...props
}: CheckboxPrimitive.Root.Props & { required?: boolean }) => {
	const checkedColor =
		required && !props.checked
			? "aria-invalid:border-error-foreground aria-invalid:ring-error-foreground border-error-foreground border-2"
			: "data-checked:bg-white data-checked:text-white-foreground data-checked:border-white aria-invalid:aria-checked:border-white";

	return (
		<CheckboxPrimitive.Root
			data-slot="checkbox"
			className={cn(
				`focus-visible:border-ring focus-visible:ring-ring/50 peer relative flex size-4 shrink-0 items-center
				justify-center rounded-sm border border-input transition-colors outline-none group-has-disabled/field:opacity-50
				after:absolute after:-inset-x-3 after:-inset-y-2 hover:cursor-pointer focus-visible:ring-3
				disabled:cursor-not-allowed disabled:opacity-50`,
				checkedColor,
				className,
			)}
			{...props}
		>
			<CheckboxPrimitive.Indicator
				data-slot="checkbox-indicator"
				className="grid place-content-center text-current transition-none [&>svg]:size-3.5"
			>
				<CheckIcon />
			</CheckboxPrimitive.Indicator>
		</CheckboxPrimitive.Root>
	);
};

Checkbox.displayName = "Checkbox";
